if (!customElements.get('meta-collapsible')) {
  customElements.define(
    'meta-collapsible',
    class MetaCollapsible extends HTMLElement {
      constructor(){
        super();
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        if(this.details && this.summary) {
          this.summary.addEventListener('click', (e) => {
            if(e.isTrusted) {
              this.closeAll();
            }
          });
        }
      }

      closeAll() {
        const collapsibles = document.querySelectorAll('meta-collapsible');
        if(collapsibles) {
          [...collapsibles].forEach(collapse => {
            if(collapse !== this) {
              let openDetails = collapse.querySelector("details[open]");
              if(openDetails) {
                let innerSummary = collapse.querySelector('summary');
                if(innerSummary) innerSummary.click();
              }
            }
          });
        }
      }
    }
  )
}